import { AutoAwesome } from '@mui/icons-material';
import { Box } from '@mui/material';
import React from 'react';
import { FeatureGate, FeatureType } from '../../context/FeatureContext';
import { tagOrHeading } from '../../services/TemplateUtils';
import { Palette } from 'Palette';
import { StyledFilterButton } from '../styles/styles';
import { FundOpportunityEOIInstance } from './controller';

export function FundOpportunityEOIFilters({
  instance,
}: {
  instance: FundOpportunityEOIInstance;
}): JSX.Element {
  const currentFilter = instance.state.filter;
  const content = instance.state.contentManagementInterface;
  const { investor, fundOpportunity, printMode } = instance.state;
  const showEOIFilter = investor?.status === 'LEAD' && fundOpportunity?.status === 'EOI';
  const veraFilterActive = !printMode && currentFilter === 'Vera';

  return (
    <>
      <Box mt={0} display="flex" flexWrap="wrap" gap={1}>
        <StyledFilterButton
          active={!instance.state.printMode && currentFilter === 'All'}
          onClick={() => instance.setFilter('All')}
        >
          All
        </StyledFilterButton>

        {content?.content?.map((item) => {
          const id = item.id;
          // A Subtitle is a break inside a section, not a section of its own, so it gets no filter.
          const label =
            item.type !== 'Subtitle' && 'heading' in item.properties
              ? tagOrHeading(item.properties.heading)
              : '';
          const isActive = !printMode && currentFilter === id;

          return (
            label && (
              <StyledFilterButton key={id} active={isActive} onClick={() => instance.setFilter(id)}>
                {label}
              </StyledFilterButton>
            )
          );
        })}

        {showEOIFilter && (
          <StyledFilterButton
            key={'eoi'}
            active={!printMode && currentFilter === 'EOI'}
            onClick={() => instance.setFilter('EOI')}
          >
            EOI
          </StyledFilterButton>
        )}

        {!instance.props.referrer && !instance.props.hideVera && (
          <FeatureGate feature={FeatureType.FeatureAiChat}>
            <StyledFilterButton
              key="vera"
              active={veraFilterActive}
              onClick={() => instance.setFilter('Vera')}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.35rem',
                backgroundColor: veraFilterActive ? undefined : Palette.tone1.buttonBg,
                color: veraFilterActive ? undefined : Palette.tone1.buttonText,
                border: veraFilterActive ? undefined : `1px solid ${Palette.tone1.buttonText}`,
                '&:hover': {
                  backgroundColor: Palette.tone2.buttonBg,
                },
              }}
            >
              <AutoAwesome fontSize="small" />
              Vera
            </StyledFilterButton>
          </FeatureGate>
        )}
      </Box>
    </>
  );
}
